/**
 * 回访列表：按进路方向格式化单元格 / 列名（与编辑进路表单字段一一对应，禁止堆进「补充」）
 */
import caseOptions from "./caseOptions.js";

function pd() {
  return caseOptions.pathDirection;
}

export function formatVisitEnglish(row) {
  if (row.englishType) {
    if (row.englishScore != null && row.englishScore !== "") {
      return row.englishType + " " + row.englishScore;
    }
    return row.englishType;
  }
  return row.english || "";
}

/** 是否就职进路（兼容存库「在日就职」与旧值/展示「就职」） */
export function isJobPath(dir) {
  if (!dir) return false;
  return dir === pd().job || dir === "就职";
}

/** 合格时间（升学类；就职/回国等为空） */
export function visitColEligibilityTime(row) {
  if (isJobPath(row.pathDirection)) return "";
  var d = pd();
  var dir = row.pathDirection;
  if (
    !dir ||
    dir === d.returnHome ||
    dir === d.other ||
    dir === d.invest
  ) {
    return "";
  }
  return row.eligibilityTime || "";
}

/** 入职时间（仅就职） */
export function visitColJobStartOnly(row) {
  if (!isJobPath(row.pathDirection)) return "";
  return row.jobStartTime || "";
}

/** 合格时间 / 入职时间（兼容旧单列） */
export function visitColTime1(row) {
  if (isJobPath(row.pathDirection)) return row.jobStartTime || "";
  return visitColEligibilityTime(row);
}

/** 入学时间（就职/回国无） */
export function visitColIncomeDate(row) {
  var d = pd();
  if (isJobPath(row.pathDirection) || row.pathDirection === d.returnHome) return "";
  return row.incomeDate || "";
}

/** 院校 / 回国原因（就职用独立「就职企业」列） */
export function visitColSchool(row) {
  var d = pd();
  var dir = row.pathDirection;
  if (isJobPath(dir)) return "";
  if (dir === d.returnHome) return row.returnReason || "";
  return row.enrollSchool || row.school || row.specialName || "";
}

/** 就职企业（存 EnrollSchool，与导入模板一致） */
export function visitColCompanyName(row) {
  if (row.pathDirection && !isJobPath(row.pathDirection)) return "";
  return row.enrollSchool || row.school || row.company || "";
}

/** 专业 / 研究科（就职改用独立「大概年薪」列） */
export function visitColMajor(row) {
  var d = pd();
  var dir = row.pathDirection;
  if (isJobPath(dir)) return "";
  if (dir === d.returnHome || dir === d.other || dir === d.invest) return "";
  if (dir === d.xiuShi || dir === d.phd || dir === d.preparatory) return row.researchDept || row.specialization || "";
  return row.enrollMajor || row.profession || "";
}

/** 行业（就职） */
export function visitColIndustry(row) {
  if (row.pathDirection && !isJobPath(row.pathDirection)) return "";
  return row.industry || "";
}

/** 岗位（就职） */
export function visitColPosition(row) {
  if (row.pathDirection && !isJobPath(row.pathDirection)) return "";
  return row.position || "";
}

/** 大概年薪（就职） */
export function visitColAnnualSalary(row) {
  if (row.pathDirection && !isJobPath(row.pathDirection)) return "";
  return row.annualSalary || "";
}

export function visitColEju(row) {
  var d = pd();
  var dir = row.pathDirection;
  if (dir && dir !== d.xueBu && dir !== d.zhuanShengBen) return "";
  return row.ejuScore || "";
}

export function visitColEnrollMethod(row) {
  if (isJobPath(row.pathDirection)) return "";
  var d = pd();
  if (row.pathDirection === d.returnHome) return "";
  return row.enrollMethod || "";
}

export function visitColInternalExam(row) {
  var d = pd();
  var dir = row.pathDirection;
  if (dir === d.zhuanMen || isJobPath(dir) || dir === d.returnHome || dir === d.other) return "";
  return row.internalExam || "";
}

export function visitColJapanese(row) {
  var d = pd();
  if (row.pathDirection === d.returnHome || row.pathDirection === d.other) return "";
  return row.japaneseScore || row.japanese || "";
}

export function visitColEnglish(row) {
  var d = pd();
  var dir = row.pathDirection;
  if (dir === d.zhuanMen || dir === d.returnHome || dir === d.other) {
    return "";
  }
  return formatVisitEnglish(row);
}

export function visitColExamExperience(row) {
  var d = pd();
  var dir = row.pathDirection;
  if (dir === d.zhuanMen || isJobPath(dir) || dir === d.returnHome || dir === d.other) return "";
  return row.examExperience || "";
}

export function visitColCompanyType(row) {
  if (row.pathDirection && !isJobPath(row.pathDirection)) return "";
  return row.companyType || "";
}

export function visitColCompanyScale(row) {
  if (row.pathDirection && !isJobPath(row.pathDirection)) return "";
  return row.companyScale || "";
}

export function visitColJobPath(row) {
  if (row.pathDirection && !isJobPath(row.pathDirection)) return "";
  return row.jobPath || "";
}

export function visitColJobExperience(row) {
  if (row.pathDirection && !isJobPath(row.pathDirection)) return "";
  return row.jobExperience || "";
}

export function visitColOther(row) {
  var d = pd();
  var dir = row.pathDirection;
  if (dir === d.phd && !row.otherRemark && !row.other) {
    return row.examExperience || "";
  }
  return row.otherRemark || row.other || "";
}

/**
 * 列表字段模式：job=仅就职列 / study=仅升学列 / all=全部（混合页）
 * 1) 优先筛选项
 * 2) 未筛：按「第一次进路」(pathOrder=1) 判断当前页是否一致
 */
export function resolveVisitPathColMode(queryDir, tableData) {
  if (isJobPath(queryDir)) return "job";
  if (queryDir) return "study";
  if (!tableData || !tableData.length) return "all";
  // 需求「第一次进路」：优先只看进路1
  var firstPaths = tableData.filter(function(r) {
    return r.pathOrder === 1 || r.pathOrder === "1";
  });
  var sample = firstPaths.length ? firstPaths : tableData;
  var dirs = sample.map(function(r) { return r.pathDirection; }).filter(Boolean);
  if (!dirs.length) return "all";
  if (dirs.every(isJobPath)) return "job";
  if (dirs.every(function(d) { return !isJobPath(d); })) return "study";
  return "all";
}

/** @deprecated 保留兼容，列表已拆独立列 */
export function visitColExtra(row) {
  return visitColOther(row);
}

function pushPart(parts, label, value) {
  if (value == null || value === "") return;
  parts.push(label + "：" + value);
}

/**
 * 单条进路在列表中的详情文案（与编辑表单字段对应，多进路时每条各一行内容）
 */
export function formatVisitPathDetail(path) {
  if (!path || !path.pathDirection) return "";
  var d = pd();
  var dir = path.pathDirection;
  var parts = [];
  if (path.eduBack) parts.push(path.eduBack);
  if (path.artsScience) parts.push(path.artsScience);

  if (isJobPath(dir)) {
    pushPart(parts, "入职", path.jobStartTime);
    pushPart(parts, "就职企业", path.enrollSchool);
    pushPart(parts, "企业", [path.companyType, path.companyScale].filter(Boolean).join("/"));
    pushPart(parts, "行业", path.industry);
    pushPart(parts, "岗位", path.position);
    pushPart(parts, "年薪", path.annualSalary);
    pushPart(parts, "日语", path.japaneseScore);
    pushPart(parts, "英语", path.englishType);
    pushPart(parts, "历程", path.jobPath);
    pushPart(parts, "经验", path.jobExperience);
  } else if (dir === d.returnHome) {
    pushPart(parts, "回国原因", path.returnReason);
  } else if (dir === d.other || dir === d.invest) {
    pushPart(parts, "说明", path.otherRemark);
  } else if (dir === d.zhuanMen) {
    pushPart(parts, "入学", path.incomeDate);
    pushPart(parts, "学校", path.enrollSchool);
    pushPart(parts, "专业", path.enrollMajor);
    pushPart(parts, "日语", path.japaneseScore);
  } else if (dir === d.zhuanShengShuo) {
    pushPart(parts, "入学方式", path.enrollMethod);
    pushPart(parts, "大学", path.enrollSchool);
    pushPart(parts, "研究科", path.enrollMajor);
    pushPart(parts, "日语", path.japaneseScore);
    pushPart(parts, "英语", path.englishType);
    pushPart(parts, "校内考", path.internalExam);
    pushPart(parts, "经验", path.examExperience);
  } else if (dir === d.bianRu) {
    pushPart(parts, "大学", path.enrollSchool);
    pushPart(parts, "专业", path.enrollMajor);
    pushPart(parts, "日语", path.japaneseScore);
    pushPart(parts, "英语", path.englishType);
    pushPart(parts, "校内考", path.internalExam);
    pushPart(parts, "经验", path.examExperience);
  } else if (dir === d.xiuShi || dir === d.phd || dir === d.preparatory) {
    pushPart(parts, "合格", path.eligibilityTime);
    pushPart(parts, "入学", path.incomeDate);
    pushPart(parts, "大学院", path.enrollSchool);
    pushPart(parts, "研究科", path.researchDept || path.specialization || path.enrollMajor);
    pushPart(parts, "日语", path.japaneseScore);
    pushPart(parts, "英语", path.englishType);
    pushPart(parts, "校内考", path.internalExam);
    pushPart(parts, dir === d.phd ? "说明" : "经验", path.examExperience);
  } else {
    // 学部 / 专升本 等
    pushPart(parts, "合格", path.eligibilityTime);
    pushPart(parts, "入学", path.incomeDate);
    pushPart(parts, "学校", path.enrollSchool);
    pushPart(parts, "专业", path.enrollMajor);
    pushPart(parts, "EJU", path.ejuScore);
    pushPart(parts, "日语", path.japaneseScore);
    pushPart(parts, "英语", path.englishType);
    pushPart(parts, "校内考", path.internalExam);
    pushPart(parts, "经验", path.examExperience);
  }
  return parts.join(" · ");
}

/** 各进路下列名（与编辑进路表单 label 一致） */
export function getVisitColLabels(dir) {
  var d = pd();
  var empty = {
    time1: "",
    incomeDate: "",
    school: "",
    major: "",
    eju: "",
    enrollMethod: "",
    internalExam: "",
    japanese: "",
    english: "",
    examExperience: "",
    companyType: "",
    companyScale: "",
    companyName: "",
    industry: "",
    position: "",
    annualSalary: "",
    jobPath: "",
    jobExperience: "",
    other: ""
  };
  if (!dir) {
    // 混合进路：列名与表单字段对齐，就职字段单独列出，避免「院校/单位」等含糊合并
    return Object.assign({}, empty, {
      time1: "合格/入职时间",
      incomeDate: "入学时间",
      school: "院校",
      major: "专业",
      eju: "EJU分数",
      enrollMethod: "入学方式",
      internalExam: "校内考",
      japanese: "日语",
      english: "英语成绩",
      examExperience: "考学经验",
      companyType: "企业类型",
      companyScale: "企业规模",
      companyName: "就职企业",
      industry: "行业",
      position: "岗位",
      annualSalary: "大概年薪",
      jobPath: "就职历程",
      jobExperience: "就职经验",
      other: "其他"
    });
  }

  var map = {};
  map[d.xueBu] = Object.assign({}, empty, {
    time1: "合格时间",
    incomeDate: "入学时间",
    school: "入学学校",
    major: "入学专业",
    eju: "最终EJU分数",
    internalExam: "校内考",
    japanese: "日语成绩",
    english: "英语成绩",
    examExperience: "考学经验"
  });
  map[d.xiuShi] = Object.assign({}, empty, {
    time1: "合格时间",
    incomeDate: "入学时间",
    school: "大学院",
    major: "研究科",
    internalExam: "校内考情况",
    japanese: "日语成绩",
    english: "英语成绩",
    examExperience: "考学经验"
  });
  map[d.preparatory] = Object.assign({}, map[d.xiuShi]);
  map[d.zhuanShengBen] = Object.assign({}, empty, {
    time1: "合格时间",
    incomeDate: "入学时间",
    school: "入学学校",
    major: "入学专业",
    eju: "最终EJU分数",
    internalExam: "校内考情况",
    japanese: "日语成绩",
    english: "英语成绩",
    examExperience: "考学经验"
  });
  map[d.zhuanShengShuo] = Object.assign({}, empty, {
    enrollMethod: "入学方式",
    school: "合格大学",
    major: "研究科",
    japanese: "日语成绩",
    english: "英语成绩",
    internalExam: "校内考情况",
    examExperience: "经验分享"
  });
  map[d.bianRu] = Object.assign({}, empty, {
    school: "编入大学",
    major: "编入专业",
    japanese: "日语成绩",
    english: "英语成绩",
    internalExam: "校内考情况",
    examExperience: "经验分享"
  });
  map[d.zhuanMen] = Object.assign({}, empty, {
    incomeDate: "入学时间",
    school: "入学学校",
    major: "所学专业",
    japanese: "日语成绩"
  });
  // 与编辑进路「在日就职」表单字段一一对应
  map[d.job] = Object.assign({}, empty, {
    time1: "入职时间",
    companyType: "企业类型",
    companyScale: "企业规模",
    companyName: "就职企业",
    industry: "行业",
    position: "岗位",
    annualSalary: "大概年薪",
    japanese: "日语成绩",
    english: "英语成绩",
    jobPath: "就职历程",
    jobExperience: "就职经验"
  });
  map[d.returnHome] = Object.assign({}, empty, {
    school: "回国原因"
  });
  map[d.phd] = Object.assign({}, empty, {
    time1: "合格时间",
    incomeDate: "入学时间",
    school: "大学院",
    major: "研究科",
    japanese: "日语成绩",
    english: "英语成绩",
    other: "说明"
  });
  map[d.invest] = Object.assign({}, empty, {
    other: "投资经营说明"
  });
  map[d.other] = Object.assign({}, empty, {
    other: "其他"
  });
  return map[dir] || empty;
}

/** 各进路下是否显示该列 */
export function getVisitColVisibility(dir) {
  var labels = getVisitColLabels(dir);
  var show = {};
  Object.keys(labels).forEach(function(key) {
    show[key] = !!labels[key];
  });
  return show;
}

/** 优先筛选项，否则当前页进路一致时取该进路 */
export function resolveVisitListPathDirection(queryDir, tableData) {
  if (queryDir) return queryDir;
  if (!tableData || !tableData.length) return "";
  var dirs = tableData.map(function(r) { return r.pathDirection; }).filter(Boolean);
  if (!dirs.length) return "";
  var first = dirs[0];
  if (dirs.every(function(d) { return d === first; })) return first;
  return "";
}
